var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"consult-container"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"code-container"},[_c('img',{staticClass:"img",attrs:{"src":_vm.imageUrl,"alt":"加载失败，刷新重试"}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }